import React from 'react';
import { useSelector } from 'react-redux';
import { useQuery, useMutation } from 'react-fetching-library';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  ListItemSecondaryAction,
  Divider,
  IconButton,
  Portal,
  CircularProgress
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { BarChart } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Iconify from '../../../components/Iconify';
import {
  getSpreadsheetTemplates,
  downloadSpreadsheet,
  deleteSpreadsheetTemplateAction,
  getTransportReport,
  getPromotionsReport,
  getSeatAvailabilityReport,
  getSeatAvailabilityResortReport,
  seatAvailabilityExcelReportAction,
  seatAvailabilityExcelReportNoAgeRangeAction,
  getMainReportZS,
  getMainReportZSManager,
  eventGroupExcelReport,
  getSaleExecutionReport,
  getQualificationCardList,
  getComprehensiveSalesPlanReport,
  getTransport2Report,
  getActivitiesListReport,
  getResignationReport,
  getInitialNoPlacesOrdersReport
} from '../../../services/request';
import { GenerateSeatAvailabilityNoAgeRangeModal } from './GenerateSeatAvailabilityNoAgeRangeModal';
import CreateSpreadsheetTemplateModal from './CreateSpreadsheetTemplateModal';
import CreateSummaryModal from './CreateSummaryReport';
import EditSpreadsheetTemplateModal from './EditSpreadsheetTemplateModal';
import GenerateSalesReportModal from './GenerateSalesReportModal';
import TransportReportDraggable from './TransportReportDraggable';
import TransportSumReportModal from './TransportSumReport';
import CropLandscapeIcon from '@mui/icons-material/CropLandscape';
import EditIcon from '@mui/icons-material/Edit';
import toast from 'react-hot-toast';

export default function GenerateSpreadsheet({ idList }) {
  const { module, seasonYear } = useSelector(state => state.app);
  const { mutate } = useMutation(downloadSpreadsheet);
  const { loading, payload, error } = useQuery(getSpreadsheetTemplates());
  const { mutate: deleteMutate } = useMutation(deleteSpreadsheetTemplateAction);
  const { mutate: transportMutate, loading: transportLoading } =
    useMutation(getTransportReport);
  const { mutate: transportSumMutate, loading: transportSumLoading } =
    useMutation(getTransportReport);
  const { mutate: promotionsMutate, loading: promotionLoading } =
    useMutation(getPromotionsReport);
  const { mutate: seatAvailabilityMutate, loading: seatAvailabilityLoading } =
    useMutation(seatAvailabilityExcelReportAction);
  const { mutate: seatAvailabilityNoAgeRangeMutate, loading: seatAvailabilityNoAgeRangeLoading } =
    useMutation(seatAvailabilityExcelReportNoAgeRangeAction);
  const {
    mutate: seatAvailabilityResortMutate,
    loading: seatAvailabilityResortLoading
  } = useMutation(getSeatAvailabilityResortReport);

  const {
    mutate: seatAvailabilityExcelMutate,
    loading: seatAvailabilityExcelLoading
  } = useMutation(seatAvailabilityExcelReportAction);
  const {
    mutate: seatAvailabilityNoAgeRangeExcelMutate,
    loading: seatAvailabilityNoAgeRangeExcelLoading
  } = useMutation(seatAvailabilityExcelReportNoAgeRangeAction);


  const { mutate: mainReportMutate, loading: mainReportLoading } =
    useMutation(getMainReportZS);
  const {
    mutate: qualificationCardsList,
    loading: qualificationCardsListLoading
  } = useMutation(getQualificationCardList);

  const { mutate: mainReportManagerMutate, loading: mainReportManagerLoading } =
    useMutation(getMainReportZSManager);
  const {
    mutate: saleExecutionReportMutate,
    loading: saleExecutionReportLoading
  } = useMutation(getSaleExecutionReport);
  const {
    mutate: comprehensiveSalesPlanReportMutate,
    loading: comprehensiveSalesPlanReportLoading
  } = useMutation(getComprehensiveSalesPlanReport);
  const { mutate: eventGroupMutate, loading: eventGroupLoading } = useMutation(
    eventGroupExcelReport
  );
  const { mutate: transportReport2Mutate, loading: transportReport2Loading } =
    useMutation(getTransport2Report);
  const { mutate: activitiesListReportMutate, loading: activitiesListReportLoading } =
    useMutation(getActivitiesListReport);
  const { mutate: resignationsMutate, loading: resignationsLoading } = useMutation(
    getResignationReport
  );
  const { mutate: initialNoPlacesOrdersReportMutate, loading: initialNoPlacesOrdersReportLoading } =
    useMutation(getInitialNoPlacesOrdersReport);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openAddTemplateModal, setOpenAddTemplateModal] = React.useState(false);
  const [openSummaryModal, setOpenSummaryModal] = React.useState(false);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [openSalesModal, setOpenSalesModal] = React.useState(false);
  const [templates, setTemplates] = React.useState([]);
  const [templateId, setTemplateId] = React.useState(0);
  const [showTransportReport, setShowTransportReport] = React.useState(false);
  const [showTransportSumReport, setShowTransportSumReport] =
    React.useState(false);
  const [openSeatAvailabilityNoAgeRangeModal, setOpenSeatAvailabilityNoAgeRangeModal] =
     React.useState(false);

  const handleOpenAddTemplateModal = () => {
    setOpenAddTemplateModal(true);
    handleClose();
  };

  const handleOpenSummaryModal = () => {
    setOpenSummaryModal(true);
    handleClose();
  };

  const handleCloseModal = () => setOpenAddTemplateModal(false);

  const handleOpenEditModal = id => {
    setOpenEditModal(true);
    setTemplateId(id);
    handleClose();
  };

  const handleOpenSalesModal = () => {
    setOpenSalesModal(true);
    handleClose();
  };

  const handleCloseSalesModal = () => setOpenSalesModal(false);

  const handleCloseEditModal = () => setOpenEditModal(false);

  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = async (id, name) => {
    const { error: mutateError, payload: mutatePayload } = await mutate(id, {
      id_list: idList
    });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `${name}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadTransportReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await transportMutate({ id_list: idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Transport.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadPromotionsReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await promotionsMutate({ id_list: idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Promocje.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadSeatAvailabilityReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await seatAvailabilityMutate();
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport sprzedaży i dostępności miejsc.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadqualificationCardsList = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await qualificationCardsList({ id_list: idList });

    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Komplet kart kwalifikacyjnych.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadSeatAvailabilityResortReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await seatAvailabilityResortMutate();
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport sprzedaży i dostępności miejsc ośrodkami.pdf';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadSeatAvailabilityExcelReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
    await seatAvailabilityExcelMutate({ id_list: idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport sprzedaży i dostępności miejsc excel.xls';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadSeatAvailabilityNoAgeRangeExcelReport = async selectedDate => {
    const { error: mutateError, payload: mutatePayload } =
      await seatAvailabilityNoAgeRangeExcelMutate({
        // id_list: idList,
        report_date: selectedDate
      });

    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download =
        `Raport sprzedaży i dostępności miejsc bez podziału na grupy wiekowe excel na ${selectedDate}.xls`;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };


  const handleDownloadMainReportZS = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await mainReportMutate({ id_list: idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Główny raport.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadMainReportZSManager = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await mainReportManagerMutate({ id_list: idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport dla kierowników.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadSalesExecutionReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await saleExecutionReportMutate({ id_list: idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().slice(0, 10); // Formatowanie na 'YYYY-MM-DD'
      const fileName = `Raport dokładnej realizacji sprzedaży ${formattedDate}.xlsx`;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadComprehensiveSalesPlanReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await comprehensiveSalesPlanReportMutate({ id_list: idList });
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().slice(0, 10); // Formatowanie na 'YYYY-MM-DD'
      const fileName = `Raport - plan całościowej sprzedaży ${formattedDate}.xlsx`;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadEventGroupReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await eventGroupMutate();
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport ilość grup.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadTransportReport2 = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await transportReport2Mutate();
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().slice(0, 10); // Formatowanie na 'YYYY-MM-DD'
      a.download = `Raport transportów ${formattedDate}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadActivitiesListReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await activitiesListReportMutate();
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Wykaz zajęć.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadResignationReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await resignationsMutate();
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Raport rezygnacji.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDownloadInitialNoPlacesOrdersReport = async () => {
    const { error: mutateError, payload: mutatePayload } =
      await initialNoPlacesOrdersReportMutate();
    if (!mutateError) {
      const url = window.URL.createObjectURL(mutatePayload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Wykaz zamówień o pierwotnym statusie brak miejsc.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
      handleClose();
    } else {
      toast.error('Nie udało się pobrać raportu');
    }
  };

  const handleDelete = async id => {
    const { error: mutateError, payload: mutatePayload } = await deleteMutate(
      id
    );
    if (!mutateError) {
      setTemplates(prev => prev.filter(template => template.id !== id));
      toast.success('Szablon został usunięty');
    } else {
      toast.error('Nie udało się usunąć');
    }
  };

  React.useEffect(() => {
    if (!error && !loading) {
      setTemplates(payload.results);
    }
  }, [loading]);

  return (
    <>
      <Box sx={{ p: 3, width: '100%', display: 'flex', flexDirection: 'row' }}>
        <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          variant="contained"
          fullWidth
          endIcon={<Iconify icon={'ri:file-excel-2-fill'} />}
          onClick={handleClick}
        >
          Wygeneruj raport
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{ 'aria-labelledby': 'basic-button' }}
          style={{ maxHeight: '60vh' }}
        >
          {reportsConfig({
            module,
            seasonYear,
            handleClose,
            handleDownloadSeatAvailabilityReport,
            seatAvailabilityLoading,
            handleDownloadSeatAvailabilityResortReport,
            seatAvailabilityResortLoading,
            handleDownloadSeatAvailabilityExcelReport,
            seatAvailabilityExcelLoading,
            // handleDownloadSeatAvailabilityNoAgeRangeExcelReport,
            // seatAvailabilityNoAgeRangeLoading,
            handleOpenSalesModal,
            handleDownloadqualificationCardsList,
            qualificationCardsListLoading,
            handleDownloadTransportReport2,
            transportReport2Loading,
            handleDownloadEventGroupReport,
            eventGroupLoading,
            handleDownloadMainReportZS,
            mainReportLoading,
            handleDownloadMainReportZSManager,
            mainReportManagerLoading,
            handleDownloadSalesExecutionReport,
            saleExecutionReportLoading,
            handleDownloadComprehensiveSalesPlanReport,
            comprehensiveSalesPlanReportLoading,
            setShowTransportReport,
            setShowTransportSumReport,
            transportLoading,
            handleDownloadPromotionsReport,
            promotionLoading,
            handleOpenAddTemplateModal,
            activitiesListReportLoading,
            handleDownloadActivitiesListReport,
            resignationsLoading,
            handleDownloadResignationReport,
            handleOpenSummaryModal,
            handleDownloadInitialNoPlacesOrdersReport,
            setOpenSeatAvailabilityNoAgeRangeModal
          })
            .filter(item => item.visible)
            .map((item, index) => (
              <MenuItem
                key={index}
                onClick={item.onClick}
                disabled={item.loading}
              >
                <ListItemIcon>
                  {item.loading ? (
                    <CircularProgress size={20} />
                  ) : (
                    item.icon || <FileDownloadIcon />
                  )}
                </ListItemIcon>
                <ListItemText>{item.label}</ListItemText>
              </MenuItem>
            ))}

          <Divider>Szablony</Divider>
          {templates.map(template => (
            <ListItem key={template.id} sx={{ pr: '96px' }} disablePadding>
              <ListItemButton
                onClick={() => handleDownload(template.id, template.template_name)
                }
              >
                <ListItemIcon>
                  <FileDownloadIcon />
                </ListItemIcon>
                <ListItemText>{template.template_name}</ListItemText>
              </ListItemButton>
              <ListItemSecondaryAction
                sx={{
                  width: '96px',
                  display: 'flex',
                  justifyContent: 'space-around'
                }}
              >
                <IconButton onClick={() => handleOpenEditModal(template.id)}>
                  <EditIcon color="primary" />
                </IconButton>
                <IconButton onClick={() => handleDelete(template.id)}>
                  <DeleteIcon color="error" />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </Menu>
      </Box>
      {openAddTemplateModal ? (
        <CreateSpreadsheetTemplateModal
          open={openAddTemplateModal}
          handleClose={handleCloseModal}
          setTemplates={setTemplates}
        />
      ) : null}
      {openEditModal ? (
        <EditSpreadsheetTemplateModal
          open={openEditModal}
          handleClose={handleCloseEditModal}
          templateId={templateId}
        />
      ) : null}
      {openSalesModal ? (
        <GenerateSalesReportModal
          open={openSalesModal}
          handleClose={handleCloseSalesModal}
        />
      ) : null}
      {showTransportReport ? (
        <TransportReportDraggable
          handleClose={() => setShowTransportReport(false)}
        />
      ) : null}
      {showTransportSumReport ? (
        <TransportSumReportModal
          open={showTransportSumReport}
          handleClose={() => setShowTransportSumReport(false)}
        />
      ) : null}
      {openAddTemplateModal ? (
        <CreateSpreadsheetTemplateModal
          open={openAddTemplateModal}
          handleClose={handleCloseModal}
          setTemplates={setTemplates}
        />
      ) : null}
      {openSummaryModal ? (
        <CreateSummaryModal
          open={openSummaryModal}
          handleClose={() => setOpenSummaryModal(false)}
        />
      ) : null}
      {openSeatAvailabilityNoAgeRangeModal && (
        <GenerateSeatAvailabilityNoAgeRangeModal
          open={openSeatAvailabilityNoAgeRangeModal}
          handleClose={() => setOpenSeatAvailabilityNoAgeRangeModal(false)}
          loading={seatAvailabilityNoAgeRangeExcelLoading}
          handleGenerate={handleDownloadSeatAvailabilityNoAgeRangeExcelReport}
        />
      )}
    </>
  );
}


// reportsConfig.js
export const reportsConfig = props => [
  {
    label: 'Raport dostępności miejsc',
    onClick: props.handleDownloadSeatAvailabilityReport,
    loading: props.seatAvailabilityLoading,
    icon: <Iconify icon={'ph:file-pdf-bold'} width={20} height={20} />,
    visible: true
  },
  {
    label: 'Raport dostępności miejsc ośrodkami',
    onClick: props.handleDownloadSeatAvailabilityResortReport,
    loading: props.seatAvailabilityResortLoading,
    icon: <Iconify icon={'ph:file-pdf-bold'} width={20} height={20} />,
    visible: true
  },
  {
    label: 'Raport dostępności miejsc EXCEL',
    onClick: props.handleDownloadSeatAvailabilityExcelReport,
    loading: props.seatAvailabilityExcelLoading,
    icon: <Iconify icon={'ph:file-xls-bold'} width={20} height={20} />,
    visible: true
  },
  {
    label: 'Raport dostępności miejsc bez podziału na grupy wiekowe EXCEL',
    onClick: () => {
      props.setOpenSeatAvailabilityNoAgeRangeModal(true);
      props.handleClose();
    },
    loading: false,
    icon: <Iconify icon={'ph:file-xls-bold'} width={20} height={20} />,
    visible: true
  },
  {
    label: 'Zestawienie sprzedaży końcowe',
    onClick: props.handleOpenSalesModal,
    loading: false,
    icon: <Iconify icon={'ph:file-pdf-bold'} width={20} height={20} />,
    visible: true
  },
  {
    label: 'Komplet kart kwalifikacyjnych',
    onClick: props.handleDownloadqualificationCardsList,
    loading: props.qualificationCardsListLoading,
    icon: <Iconify icon={'ph:file-pdf-bold'} width={20} height={20} />,
    visible:
        props.module !== 'zielone_szkoly' && Number(props.seasonYear) >= 2025
  },
  {
    label: 'Raport dot. transportów',
    onClick: props.handleDownloadTransportReport2,
    loading: props.transportReport2Loading,
    icon: <Iconify icon={'ph:file-pdf-bold'} width={20} height={20} />,
    visible: props.module === 'obozy'
  },
  {
    label: 'Raport ilość grup',
    onClick: props.handleDownloadEventGroupReport,
    loading: props.eventGroupLoading,
    icon: <Iconify icon={'mingcute:file-line'} width={20} height={20} />,
    visible: true
  },
  {
    label: 'Główny raport',
    onClick: props.handleDownloadMainReportZS,
    loading: props.mainReportLoading,
    icon: null, // możesz dodać inny typ
    visible: props.module === 'zielone_szkoly'
  },
  {
    label: 'Raport dla kierowników',
    onClick: props.handleDownloadMainReportZSManager,
    loading: props.mainReportManagerLoading,
    icon: null,
    visible: props.module === 'zielone_szkoly'
  },
  {
    label: 'Dokładna Realizacja Sprzedaży',
    onClick: props.handleDownloadSalesExecutionReport,
    loading: props.saleExecutionReportLoading,
    icon: null,
    visible: props.module === 'zielone_szkoly'
  },
  {
    label: 'Plan Całościowej Sprzedaży',
    onClick: props.handleDownloadComprehensiveSalesPlanReport,
    loading: props.comprehensiveSalesPlanReportLoading,
    icon: null,
    visible: props.module === 'zielone_szkoly'
  },
  {
    label: 'Transport',
    onClick: () => {
      props.setShowTransportReport(true);
      props.handleClose();
    },
    loading: props.transportLoading,
    icon: <CropLandscapeIcon />,
    visible: true
  },
  {
    label: 'Transport Suma',
    onClick: () => {
      props.setShowTransportSumReport(true);
      props.handleClose();
    },
    loading: props.transportLoading,
    icon: <CropLandscapeIcon />,
    visible: true
  },
  {
    label: 'Rabaty',
    onClick: props.handleDownloadPromotionsReport,
    loading: props.promotionLoading,
    icon: null,
    visible: true
  },
  {
    label: 'Wykaz zajęć',
    onClick: props.handleDownloadActivitiesListReport,
    loading: props.activitiesListReportLoading,
    icon: <Iconify icon="ph:file-xls-bold" width="20" height="20" />,
    visible: props.module === 'zielone_szkoly'
  },
  {
    label: 'Raport rezygnacji',
    onClick: props.handleDownloadResignationReport,
    loading: props.resignationsLoading,
    icon: <Iconify icon="ph:file-xls-bold" width="20" height="20" />,
    visible: props.module === 'zielone_szkoly'
  },
  {
    label: 'Raport pierwotnych "brak miejsc"',
    onClick: props.handleDownloadInitialNoPlacesOrdersReport,
    loading: props.initialNoPlacesOrdersReportLoading,
    icon: <Iconify icon="ph:file-xls-bold" width="20" height="20" />,
    visible: props.module === 'obozy'
  },
  {
    label: 'Nowy szablon',
    onClick: props.handleOpenAddTemplateModal,
    loading: false,
    icon: <AddIcon />,
    visible: true
  }
];
